// extracted by mini-css-extract-plugin
export default {"nftGrid":"ProfileLoadingPage_nftGrid__uIOYH","row1Skeleton":"ProfileLoadingPage_row1Skeleton__XpVkx","row2Skeleton":"ProfileLoadingPage_row2Skeleton__jApjM"};